export enum TypeSanctionIdentificationType {
    COMPANY = 1001,
    ROUTE =  1002,
    CHECKPOINT = 1003
}